import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from '@sparro/app/material.module';

import { HomeViewRoutingModule } from './home-view-routing.module';
import { HomeViewComponent } from './home-view/home-view.component';

import { LayoutModule } from '@sparro/app/shared/components/layout/layout.module';
import { CardsModule } from '@sparro/app/shared/components/cards/cards.module';
import { LoaderModule } from '@sparro/app/shared/components/loader/loader.module';
import { ButtonsModule } from '@sparro/app/shared/components/buttons/buttons.module';
import { PipesModule } from '@sparro/app/shared/pipes/pipes.module';

import { NavigationButtonComponent } from '@sparro/app/shared/components/buttons/blueprints/navigation-button/navigation-button.component';
import { SectionDetailComponent } from './section-detail/section-detail.component';
import { CommonComponent } from './common/common.component';

@NgModule({
  declarations: [
    HomeViewComponent,
    SectionDetailComponent,
    CommonComponent
  ],
  entryComponents: [
    NavigationButtonComponent,
  ],
  imports: [
    CommonModule,
    HomeViewRoutingModule,
    FlexLayoutModule,
    MaterialModule,
    LayoutModule,
    PipesModule,
    CardsModule,
    LoaderModule,
    ButtonsModule
  ]
})
export class HomeViewModule { }
